import { render, staticRenderFns } from "./modifyReading.vue?vue&type=template&id=36b44553"
import script from "./modifyReading.ts?vue&type=script&lang=js&external"
export * from "./modifyReading.ts?vue&type=script&lang=js&external"
import style0 from "./modifyReading.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports